import { ReactElement, ReactNode } from "react";

import { View } from "./View";

export interface ICdsGridProps {
  fullWidth?: boolean;
  condensed?: boolean;
  narrow?: boolean;
  as?: string;
  className?: string;
  columns?: number;
  children: ReactElement | ReactNode;
}

export const CdsGrid = (props: ICdsGridProps) => {
  return <View {...props} />;
};
